<script>
    import Icon from 'svelte-awesome';
    import { check } from 'svelte-awesome/icons';
    import { noop } from 'svelte/internal';
    import { getDate } from '../../helpers.svelte';
    import EditSourceButtonModal from '../../components/popups/EditSource/buttonModal.svelte'
    import feedStore from '../../stores/feed';

    export let feedSource;
    export let tagOptions;
    export let subscribeToSource;
    export let sourceLookup;

    $: isSubscribed = sourceLookup[feedSource?.hashID];
    $: roleValue = $feedStore.roleValue
    $: subscribeButtonText = isSubscribed ? 'Remove' : 'Add to Feed';

    $: isCurator = roleValue && roleValue > 1;
    $: feedSourceUrlOrigin = (new URL(feedSource.url)).origin;

    function pullFeed(e) {
        fetch(`/pull/source/${feedSource.hashID}`)
        .then(data => data.json())
        .then(response => {
            const { success } = response;
            noop();
        })
    }

</script>

<div class="source-list-item-container">
    <div class="source-list-item">
        <div class="source-title">
            <div>
                {#if feedSource.tags}
                    <div style="margin-bottom: 12px;color:#2a7e19;">
                    {#each feedSource.tags as tag}
                        <span style="margin-right: 8px;">{tag}</span>
                    {/each}
                    </div>
                {/if}
                {#if feedSource.title}
                    <div style="font-size:24px;margin-bottom:12px;font-weight:bold;">{feedSource.title}</div>
                {/if}
                <div>{feedSourceUrlOrigin}</div>
                <div style="margin-top:24px;">
                    <button
                        on:click={subscribeToSource(feedSource)}
                        class="source-item-button {isSubscribed ? 'subscribed' : ''}"
                    >
                        {subscribeButtonText}
                    </button>
                    <EditSourceButtonModal feedSource={feedSource} tagOptions={tagOptions} />
                </div>
            </div>
            {#if isCurator && feedSource.lastPulledAt}
                <div class="date-last-pulled">{getDate(feedSource.lastPulledAt)}</div>
            {/if}
        </div>
        <div class={isSubscribed ? 'is-checked' : 'not-checked'} style="display:flex;align-items:center;">
            <Icon data={check} scale={2} />
        </div>

        {#if isCurator}
            <div style="display:flex;align-items:center;">
                <a href={'#'} on:click|stopPropagation|preventDefault={pullFeed}>pull</a>
            </div>
        {/if}
    </div>
</div>

<style>
    .source-list-item-container {
        margin-bottom: 20px;
        /* cursor: pointer; */
        position:relative;
    }
    .source-list-item {
        display: flex;
        justify-content: space-between;
        padding: 30px;
        background-color:rgb(5,5,5);
        color: rgb(150,150,150);
    }
    .source-title {
        display: flex;
        align-items: center;
    }
    .source-item-button {
        padding: 10px 24px;
        margin-right: 12px;
        color: white;
        background: transparent;
        border: 1px solid;
        font-size: 12px;
    }
    .source-item-button.subscribed {
        color: black;
        background: rgb(42, 126, 25);
    }
    .not-checked {
        opacity: .2;
    }
    .date-last-pulled {
        position: absolute;
        top: 0;
    }
</style>